import React from 'react';

const addCommas = (str) => {
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatDate = (str, max) => {
  if (str.charAt(0) !== '0' || str === '00') {
    const num = Number(str);
    if (num <= 0 || num > max) {
      return '1';
    }
    if (str.length === 1 && num > Number(max.toString().charAt(0))) {
      return `0${str}`;
    }
  }
  return str;
};

const Formatters = {
  LOCALE_STRING: (val) => Number(val.replace(/[^0-9.]/g, '')).toLocaleString('en'),
  DECIMAL_CURRENCY: (val) => {
    const res = val.replace(/[^\d|.]/g, '');
    const [leadZeroWhole, decimal] = res.split(/\.(?=.)/);
    const whole = leadZeroWhole.replace(/^0+/, '');
    return addCommas(decimal ? `${whole}.${decimal.replace(/[^\d]/g, '').slice(0, 2)}` : whole || '0');
  },
  PERCENT: (val) => val.replace(/[^\d]/g, '').replace(/\d\d\d+/g, '100'),
  SSN: (val) =>
    val
      .replace(/\D/g, '')
      .substr(0, 9)
      .replace(/(\d{1,3})(\d{1,2})?(\d{1,4})?/g, (txt, f, s, t) => {
        if (t) {
          return `${f}-${s}-${t}`;
        }
        if (s) {
          return `${f}-${s}`;
        }
        if (f) {
          return `${f}`;
        }

        return '';
      }),
  DATE: (val) =>
    val
      .replace(/\D/g, '')
      .substr(0, 8)
      .replace(/(\d{1,2})(\d{1,2})?(\d{1,4})?/g, (txt, f, s, t) => {
        if (t) {
          return `${f}/${s}/${t}`;
        }
        if (s) {
          return `${f}/${formatDate(s, 31)}`;
        }
        if (f) {
          return `${formatDate(f, 12)}`;
        }

        return '';
      }),
  EIN: (val) =>
    val
      .replace(/\D/g, '')
      .substr(0, 9)
      .replace(/(\d{1,2})?(\d{1,7})?/g, (txt, f, t) => {
        if (t) {
          return `${f}-${t}`;
        }
        if (f) {
          return `${f}`;
        }

        return '';
      }),
  PHONE: (val) =>
    val
      .replace(/\D/g, '')
      .substr(0, 10)
      .replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/g, (txt, f, s, t) => {
        if (t) {
          return `(${f}) ${s}-${t}`;
        }
        if (s) {
          return `(${f}) ${s}`;
        }
        if (f) {
          return `${f}`;
        }

        return '';
      }),
};

export default Formatters;

export function FormattersList() {
  return <>{Object.keys(Formatters).join(', ')}</>;
}
